import { Ghost, Candy, Moon } from "lucide-react";

// Déco Halloween : visible du 1er octobre au 1er novembre (ou en avant-première via ?halloween=1)
export const isHalloweenSeason = () => {
  const now = new Date();
  const m = now.getMonth();
  if (m === 9) return true; // octobre
  if (m === 10 && now.getDate() === 1) return true; // 1er novembre
  return new URLSearchParams(window.location.search).has("halloween");
};

const Pumpkin = ({ className }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <path d="M24 8c-2-3.5-6-4.5-6-4.5s1 3.5 2.5 5.5" stroke="#3f6212" strokeWidth="2.5" strokeLinecap="round" />
    <ellipse cx="24" cy="27" rx="17" ry="14" fill="#F97316" />
    <ellipse cx="24" cy="27" rx="8.5" ry="14" fill="#EA6A0A" opacity="0.55" />
    <path d="M13 24c-1.5 2.5-1.5 5 0 7M35 24c1.5 2.5 1.5 5 0 7" stroke="#C2570A" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default function HalloweenDeco() {
  if (!isHalloweenSeason()) return null;
  return (
    <div
      data-testid="halloween-deco"
      aria-hidden="true"
      className="pointer-events-none fixed bottom-4 right-4 z-40 flex items-end gap-2 sm:bottom-6 sm:right-6 sm:gap-3"
    >
      <Moon className="h-5 w-5 animate-float-y text-[#CBA135] [animation-delay:0.8s] sm:h-6 sm:w-6" />
      <Ghost className="h-7 w-7 animate-float-y text-[#FAF8F5] drop-shadow-[0_2px_6px_rgba(28,18,16,0.45)] [animation-delay:0.4s] sm:h-9 sm:w-9" />
      <Candy className="h-6 w-6 animate-float-y text-[#F97316] [animation-delay:1.2s] sm:h-7 sm:w-7" />
      <Pumpkin className="h-10 w-10 animate-float-y drop-shadow-[0_3px_8px_rgba(28,18,16,0.35)] sm:h-14 sm:w-14" />
    </div>
  );
}
